import { Link } from "react-router-dom";
import { ArrowLeft, Home } from "lucide-react";

export default function NotFoundPage() {
  return (
    <div className="min-h-screen bg-lab-bg-light flex items-center justify-center px-6" data-testid="not-found-page">
      <div className="text-center max-w-lg">
        <p className="text-8xl font-playfair font-bold text-lab-primary/10 mb-4">404</p>
        <h1 className="font-playfair text-2xl lg:text-3xl font-semibold text-lab-primary -mt-12 mb-4">
          Seite nicht gefunden
        </h1>
        <p className="text-lab-text-muted mb-8">
          Die angeforderte Seite existiert nicht oder wurde verschoben.
        </p>
        <Link
          to="/"
          className="inline-flex items-center gap-2 bg-lab-primary text-white px-6 py-3 text-sm font-medium hover:bg-lab-accent hover:text-lab-primary transition-colors"
          data-testid="back-home-btn"
        >
          <Home className="w-4 h-4" />
          Zur Startseite
        </Link>
      </div>
    </div>
  );
}
